(function () {
  const prefetched = new Set();

  function prefetchPage(url) {
    if (prefetched.has(url)) return;
    prefetched.add(url);

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';

    document.head.appendChild(link);
  }

  document.addEventListener('mouseover', (e) => {
    const link = e.target.closest('[data-prefetch-link]');
    if (link) prefetchPage(link.href);
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        prefetchPage(entry.target.href);
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '200px' });

  document.querySelectorAll('[data-prefetch-link]').forEach(link => {
    observer.observe(link);
  });
})();
